import type { MembershipDetails } from '../../entities/entityTypes';
import { useRefetchMembershipDetailsMutationOptions } from '../../entities/membership/hooks/useRefetchMembershipDetailsMutationOptions';
import { requestBuilder } from '../../http/RequestBuilder';
import type { GeneralResponse } from '../../http/types/Common';

interface DeleteMembershipIncomeParams {
    id: string;
}

const useDeleteMembershipIncome = requestBuilder.mutation<
    GeneralResponse,
    null,
    DeleteMembershipIncomeParams
>({
    endpoint: ({ id }) => `/api/admin/membership-income/${id}`,
    method: 'DELETE',
});

export const useDeleteMembershipIncomeAndRefetch = (
    membership: MembershipDetails | null,
) => {
    const refetchMembershipMutationOptions =
        useRefetchMembershipDetailsMutationOptions(membership);

    const { mutateAsync } = useDeleteMembershipIncome(
        refetchMembershipMutationOptions,
    );

    const deleteMembershipIncomeAsync = async (id: string) => {
        return await mutateAsync({
            urlParams: {
                id,
            },
        });
    };

    return {
        deleteMembershipIncomeAsync,
    };
};
